import { ComponentConfig } from "@measured/puck"
import { LocationMapProps, RenderConfig } from "./RenderConfig"

export const LocationMap: ComponentConfig<LocationMapProps> = {
  label: "CaoCao | Location Map",
  fields: {
    lat: {
      label: "Latitude Position",
      type: "text",
    },
    lng: {
      label: "Longitude Position",
      type: "text",
    },
    mapHeight: {
      label: "Height of Map",
      type: "text",
    },
    locationLabel: {
      label: "Label of Location",
      type: "text",
    },
    styles: {
      label: "Styles",
      type: "object",
      objectFields: {
        desktop: {
          label: "Desktop Styles",
          type: "object",
          objectFields: {
            display: {
              label: "Display",
              type: "select",
              options: [
                { value: "flex", label: "Flex" },
                { value: "block", label: "Block" },
              ],
            },
          },
        },
        mobile: {
          label: "Mobile Styles",
          type: "object",
          objectFields: {
            display: {
              label: "Display",
              type: "select",
              options: [
                { value: "flex", label: "Flex" },
                { value: "block", label: "Block" },
              ],
            },
          },
        },
        tablet: {
          label: "Tablet Styles",
          type: "object",
          objectFields: {
            display: {
              label: "Display",
              type: "select",
              options: [
                { value: "flex", label: "Flex" },
                { value: "block", label: "Block" },
              ],
            },
          },
        },
      },
    },
    type: {
      label: "Layout Type",
      type: "select",
      options: [
        { label: "Fluid", value: "fluid" },
        { label: "Custom", value: "custom" },
        { label: "Boxed", value: "boxed" },
      ],
    },
    className: {
      label: "Class Name",
      type: "text",
    },
  },
  defaultProps: {
    lat: "10.7937069",
    lng: "106.6877516",
    mapHeight: "460px",
    locationLabel: "Cào Cào Adventures - Vietnam Cycling Tours",
    styles: {
      desktop: {
        display: "block",
      },
      mobile: {
        display: "block",
      },
      tablet: {
        display: "block",
      },
    },
    type: "fluid",
    className: "",
  },
  ...RenderConfig,
}
